export default __webpack_public_path__ + "static/media/hotel-5.eaed9ef7.jpg";